import React from 'react';
import ReactDOM from 'react-dom/client'; // Cambia a 'react-dom/client' para React 18
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* Sin BrowserRouter aquí */}
  </React.StrictMode>
  
);